import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BalanceQuery, config, PointsTransferService, PointsTransferType, PartnerQuery, Partner } from '@fgb/core';
import { Subscription, Observable } from 'rxjs';
import { OwlCarouselSettings } from 'src/app/shared/utilities/owl-carousel-settings';
import { Router } from '@angular/router';

@Component({
  selector: 'fgb-points-transfer',
  templateUrl: './points-transfer.component.html',
  styleUrls: ['./points-transfer.component.scss'],
})
export class PointsTransferComponent implements OnInit, OnDestroy {
  transferPointsForm: FormGroup;
  selectedPointsTransferType: PointsTransferType = PointsTransferType.Partner;
  PointsTransferTypes: PointsTransferType[] = [PointsTransferType.Partner, PointsTransferType.NonPartner];
  balanceSub: Subscription;
  partners$: Observable<Partner[]>;
  amount: number = 10;
  balance: number;
  customOptions: OwlOptions = {
    margin: OwlCarouselSettings.Margin,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    navSpeed: 700,
    center: false,
    nav: true,
    navText: ['<i class="icon-arrow-1-circle-left"></i>', '<i class="icon-arrow-1-circle-"></i>'],
    responsive: {
      0: { items: 2 },
      400: { items: 3 },
      740: { items: 5 },
    },
  };

  @ViewChild('successModal') successModalRef: ElementRef;
  @ViewChild('confirmModal') confirmModalRef: ElementRef;
  constructor(
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private balanceQuery: BalanceQuery,
    private pointsTransferService: PointsTransferService,
    private partnerQuery: PartnerQuery,
    private router: Router
  ) {}

  ngOnInit() {
    this.transferPointsForm = this.formBuilder.group({
      Amount: ['', [Validators.required]],
      partnerSelected: [null, [Validators.required]],
    });

    this.partners$ = this.partnerQuery.selectAll();
    this.transferPointsForm.controls.Amount.setValue(this.amount.toString());
    this.balanceSub = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty).subscribe((bal) => {
      this.balance = bal ?? 0;
    });
  }

  ngOnDestroy() {
    if (this.balanceSub) {
      this.balanceSub.unsubscribe();
    }
  }

  get isFormInvalid() {
    return this.transferPointsForm.invalid;
  }

  send() {
    if (!this.transferPointsForm.valid) {
      return;
    }
    this.transferPointsForm.controls.Amount.setValue(this.amount);
    this.modalService.open(this.confirmModalRef, { centered: true, windowClass: 'point-transfer' });
  }

  transferPoints() {
    let accountNumber = this.transferPointsForm.controls.partnerSelected.value.ExternalRefNumber;
    let amountToTransfer = this.transferPointsForm.controls.Amount.value;
    let relationshipId = this.transferPointsForm.controls.partnerSelected.value.RelationshipId;
    this.pointsTransferService
      .pointsTransfer(amountToTransfer, accountNumber)
      .toPromise()
      .then((response) => {
        this.modalService.dismissAll();
        this.router.navigate(['pointstransfer/success'], {
          queryParams: {
            idPartner: relationshipId,
            amount: amountToTransfer,
          },
        });
      })
      .catch((err) => {
        this.modalService.dismissAll();
      });
  }

  goToSuccessModal() {
    this.modalService.open(this.successModalRef, { centered: true });
  }

  closeModal() {
    this.modalService.dismissAll();
  }
}
